export const RECEIVE_STORES_REQUEST = 'RECEIVE_STORES_REQUEST';
export const SET_STORES_FETCHING = 'SET_STORES_FETCHING';
export const SET_STORES_LOADING = 'SET_STORES_LOADING';
export const TOGGLE_STORES_BOOLEAN = 'TOGGLE_STORES_BOOLEAN';
